module.exports = __webpack_public_path__ + "static/media/Desktop_Actions_30.2ba9bc24.png";